export default __webpack_public_path__ + "static/media/trbothh1.25c30c65.mp3";